<template>
    <div>
        <div class="menu-item-left volume-control" :class="{isTpg:isTpg}">
            <div class="menu-border-top" :class="{isTpg:isTpg}">
                <div style="float:left;width:23%;font-size:16px;"><b>Volume</b></div>
                <div style="float:left;width:63%;margin-left:10px;" v-if="!disableVolumeBar">
                    <div class="slider-container" v-if="clientDidSetMuted == 0" @mouseover="showLouderQuieter()" @mouseleave="hideLouderQuieter()">
                        <div class="volume-quieter" @click="decrementVolumeByOne">-</div>
                        <div class="slider-bar-container">
                            <input :class="{isTpg:isTpg}" type="range" :min="1" :max="maxValue" v-model="volumeBarValue" class="slider" steps="maxValue" @change="updateVolume()" id="volume-slider" refs="volumeSlider">
                        </div>
                        <div class="volume-louder" @click="incrementVolumeByOne" :class="{isTpg:isTpg}">+</div>
                    </div>
                    <div v-else class="unmute-text" :class="{isTpg:isTpg}"><i>This player is muted</i></div>
                </div>
                <!-- <div v-else class="spinner-container">
                    <div style="margin-top:0px;">
                        <div class="spinner black">
                            <div class="rect1"></div>
                            <div class="rect2"></div>
                            <div class="rect3"></div>
                            <div class="rect4"></div>
                            <div class="rect5"></div>
                        </div>
                    </div>
                </div> -->
                <div v-else class="processing-text" :class="{isTpg:isTpg}"><i>Player is processing volume command</i></div>
                <div class="mute-button-container">
                    <div class="mute-button" @click="mute" title="Mute" :class="{isMuted:clientDidSetMuted == 1, isTpg:isTpg}" v-if="!volumeIsDisabled">
                        <span v-if="clientDidSetMuted == 0"> <font-awesome-icon icon="volume-up"  aria-hidden="false" /></span>
                        <span v-else><div class="muted-volume-icon-dash" :class="{isTpg:isTpg}"></div> <font-awesome-icon icon="volume-off"  aria-hidden="false" /></span>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import $ from 'jquery';

export default {
  name: 'VolumeControl',
  data() {
    return {
      maxValue: this.maxVolumeIncrements, // CW-29 - (01-11-2023)
      volumeBarValue: this.volumeIndex,   // CW-29 - (01-12-2023)
      disableVolumeBar: this.volumeIsDisabled,
    };
  },
  props: ['is-tpg', 'volume', 'client-did-set-muted', 'volumeIsDisabled', 'maxVolumeIncrements', 'volumeIndex'],
  mounted() {
    this.maxValue = this.maxVolumeIncrements; // CW-29 - (01-11-2023)
    this.volumeBarValue = this.volumeIndex;   // CW-29 - (01-12-2023)
  },
  methods: {
    mute() {
      this.$emit('updateMute');
    },
    updateVolume() {
    this.$emit('updateVolume', this.volumeBarValue);
    },
    showLouderQuieter() {
      let color = 'yellow';
      if (this.isTpg) color = '#01ac81';
      $('.volume-quieter,.volume-louder').css('color', color);
    },
    hideLouderQuieter() {
      let color = 'white';
      if (this.isTpg) color = '#666';
      $('.volume-quieter,.volume-louder').css('color', color);
      $('.value-display').css('color', color);
    },
    incrementVolumeByOne() {
        if (this.volumeBarValue < this.maxValue && !this.disableVolumeBar) {
            this.volumeBarValue++;
            this.updateVolume();
        }
    },
    decrementVolumeByOne() {
        if (this.volumeBarValue > 1 && !this.disableVolumeBar) {
            this.volumeBarValue--;
            this.updateVolume();
        }
    },
  },
  computed: {
  },
  watch: {
    volume() {
      this.maxValue = this.maxVolumeIncrements; // CW-29 - (01-11-2023)
      this.volumeBarValue = this.volumeIndex;   // SI-278 - (06-29-2023)
    //   console.log("(VolumeController) maxVolumeIncrements: " + this.maxVolumeIncrements); //DEBUG
    //   console.log("(VolumeController) maxValue           : " + this.maxValue);            //DEBUG
    //   console.log("(VolumeController) volumeBarValue     : " + this.volumeBarValue);      //DEBUG
    },
    // T700 (08-05-2022)
    volumeIsDisabled() {
        this.disableVolumeBar = this.volumeIsDisabled;
    }
  },
};
</script>

<style scoped>
.volume-control {
    min-height: 42px;
    line-height: 42px;
}

.slider-container {
    height: 30px;
    width: 105%;
    margin: 0 auto;
    margin-bottom: 0px;
    background: rgba(27, 27, 27, 0.0);
}

.slider {
    -webkit-appearance: none;
    appearance: none;
    width: 144px;
    height: 1px;
    background: #fff;
    outline: none;
    opacity: .7;
    -webkit-transition: .2s;
    transition: opacity .2s;
    margin-top: 2px;
    z-index: 20;
    /*border-top:1px solid #fff;*/
}

.slider.isTpg {
    background: #666;
}

.slider:hover {
    opacity: 1;
}

.slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 10px;
    height: 18px;
    border-radius: 3px;
    background: #fff;
    cursor: pointer;
    border: 0px solid #999;
    box-shadow: 0px 2px transparent;
    cursor: pointer;
    z-index: 21;
}

.slider.isTpg::-webkit-slider-thumb {
    background: #666;
}

.slider::-moz-range-thumb {
    width: 15px;
    height: 25px;
    cursor: pointer;
}

.slider.isTpg::-ms-thumb {
    background: #666;
}

.slider::-ms-thumb {
    width: 15px;
    height: 25px;
    cursor: pointer;
}

.processing-text {
    color: yellow;
    font-size: 14px;
    line-height: 34px;
    margin: 0 auto;
    margin-bottom: 0px;
    padding: 5px;
    border-radius: 5px;
    padding-left: 15px;
}

.processing-text.isTpg {
    color: #01ac81;
}

.value-display {
    color: #efefef;
    font-weight: bold;
    font-size: 15px;
    opacity: 1;
    transition: .6s;
    margin-top: 0px;
}
.value-display.isTpg {
    color: #666;
}

.mute-button-container {
    float: right;
    width: 8%;
    text-align: center;
    margin-right: -15px;
}

.unmute-text {
    color: yellow;
    font-size: 14px;
    line-height: 34px;
    margin: 0 auto;
    margin-bottom: 0px;
    /*background:#f5cdd1;*/
    padding: 5px;
    border-radius: 5px;
    padding-left: 15px;
}

.unmute-text.isTpg {
    color: #01ac81;
}

.mute-button {
    height: 24px;
    margin: 0 auto;
    width: 24px;
    /*background:#4b4b4b;*/
    color: #ccc;
    border-radius: 12px;
    line-height: 18px;
    font-weight: bold;
    /*background:rgba(20,20,20,.8);*/
    margin-top: 10px;
    cursor: pointer;
    transition: .9s;
    border: 0px solid #666;
    position: relative;
}

.mute-button.isTpg {
    color: #666;
}

.mute-button.isMuted {
    border: 1px solid rgba(206, 60, 62, 1);
}

.mute-button.isTpg.isMuted {
    border: 1px solid #01ac81;
    ;
}

.mute-button-column {
    float: left;
    width: 65%;
}

.mute-button-column.is-icon {
    width: 30%;
}

.mute-button:hover {
    background: #6f6f6f;
}

.mute-button.isTpg:hover {
    background: #6f6f6f;
    color: #efefef;
}

.mute-button i {
    font-size: 14px;
    top: -7px;
}

.volume-level {
    font-size: 14px;
    color: #fff;
}

.volume-tick {
    float: left;
    height: 5px;
    /*border-left:1px solid #fff;*/
    width: 5px;
    border-radius: 2px;
    z-index: 1;
    background: whitesmoke;
    margin-right: 17px;
    opacity: 1;
}

.volume-tick.last-tick {
    /*border-right:1px solid #fff;*/
    margin-right: 0px;
}

.volume-tick-container {
    position: absolute;
    z-index: 16;
    height: 5px;
    width: 133px;
    top: 10px;
}

.volume-louder,
.volume-quieter {
    color: #efefef;
    font-weight: bold;
    font-size: 15px;
    opacity: 1;
    transition: .6s;
    margin-top: 0px;
    cursor: pointer;
}

.volume-louder.isTpg,
.volume-quieter.isTpg {
    color: #666;
}

.volume-louder {
    width: 16px;
    float: left;
}

.volume-quieter {
    float: left;
    width: 16px;
}

.slider-bar-container {
    float: left;
    width: 160px;
    position: relative;
    margin-top: 20px;
}

.muted-volume-icon-dash {
    width: 22px;
    position: absolute;
    top: 11px;
    left: 0px;
    transform: rotate(48deg);
    height: 1px;
    background: rgba(206, 60, 62, 1);
}

.muted-volume-icon-dash.isTpg {
    background: #01ac81;
}

.spinner {
    margin: 10px auto;
    width: 45px;
    height: 25px;
    text-align: center;
    font-size: 8px;
    margin-top: 1px;
    margin-bottom: -1px;
}

.spinner>div {
    background-color: #fff;
    height: 40%;
    width: 4px;
    display: inline-block;
    -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;
    animation: sk-stretchdelay 1.2s infinite ease-in-out;
    margin-right: 1px;
}

.spinner.black>div {
    background-color: #666;
}

.spinner .rect2 {
    -webkit-animation-delay: -1.1s;
    animation-delay: -1.1s;
}

.spinner .rect3 {
    -webkit-animation-delay: -1.0s;
    animation-delay: -1.0s;
}

.spinner .rect4 {
    -webkit-animation-delay: -0.9s;
    animation-delay: -0.9s;
}

.spinner .rect5 {
    -webkit-animation-delay: -0.8s;
    animation-delay: -0.8s;
}
.menu-border-top {
    border-top:2px solid rgba(40, 40, 40, .6);
    padding-top:10px;
}
.menu-border-top.isTpg {
    border-top:2px solid rgba(202, 202, 202, 0.6);
}
</style>
